<div class="container">
  <div class="row justify-content-between" style="padding: 20px 40px">
    <div class="col-12 align-self-center text-start">
      <h4>Set Calendar Information.</h4>
    </div>
  </div>
  <div class="dx-card wide-card"></div>
</div>
